import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { SupportActionsPage } from "@/features/support-actions";

export const Route = createFileRoute("/support-actions/")({
  component: SupportActionsRoute,
});

function SupportActionsRoute() {
  return (
    <AdminDashboardShell>
      <SupportActionsPage />
    </AdminDashboardShell>
  );
}
